import React from 'react';
import './ImageSequence.scss';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from '../../../components/FormattedHTMLMessage';

function ImageSequence({images}) {
  const nextArrow = './svg/preparation-wizard/next-icon.svg';
  const {gapSize, unresponsivePadding, captionsFormat, hideArrow, imgPaths, style} = images || {};

  const getImg = () => {
    const imgComponent = [];
    const totalImg = imgPaths.length;
    const totalImgWithArrow = totalImg * 2;

    let pathIndex = 0;

    for (let i = 0; i < totalImgWithArrow; i += 1) {
      if (i % 2 === 0) {
        const path = imgPaths[pathIndex];

        imgComponent.push(
          <span key={path} className="image-sequence__item" style={{width: `${100 / totalImgWithArrow}%`}}>
            <div className="image-sequence__item__image">
              <img className="image" alt={path} src={path} style={style} />
              {captionsFormat && (
                <span className="caption">
                  <FormattedHTMLMessage id={`${captionsFormat}${pathIndex + 1}`} />
                </span>
              )}
            </div>
          </span>,
        );

        pathIndex += 1;
      } else if (i !== totalImgWithArrow - 1 && !hideArrow) {
        imgComponent.push(
          <span key={`arrow-${i}`} className="image-sequence__item" style={{width: `${100 / totalImg}%`}}>
            <span className="image-sequence__item__arrow">
              <img className="next-arrow-image" alt={nextArrow} src={nextArrow} />
            </span>
          </span>,
        );
      }
    }

    return imgComponent;
  };

  return (
    <div
      className={`image-sequence-container image-sequence-${unresponsivePadding ? 'static' : 'responsive'}`}
      style={{gap: gapSize}}
    >
      {imgPaths && getImg()}
    </div>
  );
}

ImageSequence.propTypes = {
  images: PropTypes.object.isRequired,
};

export default ImageSequence;
